export const formatTurkmenPhone = (value = "") => {
  let input = value;

  if (!input.startsWith("+993")) {
    input = "+993" + input.replace(/[^0-9]/g, "");
  } else {
    input = "+993" + input.slice(4).replace(/[^0-9]/g, "");
  }

  if (input.length > 12) {
    input = input.slice(0, 12);
  }

  return input;
};

export const isValidEmail = (email = "") => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
};

export const isValidTurkmenPhone = (phone = "") => {
  return phone.startsWith("+993") && phone.length === 12;
};

export const validateActRequestForm = ({ data, requesterType, t }) => {
  const errors = {};

  const requiredMessage = t("all_must");
  const invalidEmailMessage = t("invalid_email") || "Email nädogry";
  const phoneMessage = t("required_phone") || requiredMessage;

  if (requesterType === "organization") {
    if (!data.organization_name?.trim()) {
      errors.organization_name = requiredMessage;
    }
  }

  if (!data.province) {
    errors.province = requiredMessage;
  }

  if (!data.district) {
    errors.district = requiredMessage;
  }

  if (!data.first_name?.trim()) {
    errors.first_name = requiredMessage;
  }

  if (!data.last_name?.trim()) {
    errors.last_name = requiredMessage;
  }

  if (!data.patronimic?.trim()) {
    errors.patronimic = requiredMessage;
  }

  if (!data.places) {
    errors.places = requiredMessage;
  }

  if (!data.act) {
    errors.act = requiredMessage;
  }

  if (!data.email?.trim()) {
    errors.email = requiredMessage;
  } else if (!isValidEmail(data.email)) {
    errors.email = invalidEmailMessage;
  }

  if (!data.message?.trim()) {
    errors.message = requiredMessage;
  }

  if (!isValidTurkmenPhone(data.phone_number)) {
    errors.phone_number = phoneMessage;
  }

  if (!data.attachment) {
    errors.attachment = requiredMessage;
  }

  return errors;
};

export const isActRequestFormComplete = (data, requesterType) => {
  const commonFieldsFilled =
    data.province &&
    data.district &&
    data.first_name?.trim() &&
    data.last_name?.trim() &&
    data.patronimic?.trim() &&
    data.places &&
    data.act &&
    data.email?.trim() &&
    data.message?.trim() &&
    data.attachment &&
    isValidTurkmenPhone(data.phone_number);

  if (requesterType === "organization") {
    return Boolean(commonFieldsFilled && data.organization_name?.trim());
  }

  return Boolean(commonFieldsFilled);
};

export const buildActRequestFormData = (payload) => {
  const formData = new FormData();

  formData.append("requester_type", payload.requester_type);
  formData.append("province", payload.province);
  formData.append("district", payload.district);
  formData.append("first_name", payload.first_name);
  formData.append("last_name", payload.last_name);
  formData.append("patronimic", payload.patronimic);
  formData.append("places", payload.places);
  formData.append("act", payload.act);
  formData.append("email", payload.email);
  formData.append("message", payload.message);
  formData.append("phone_number", payload.phone_number);

  if (payload.organization_name) {
    formData.append("organization_name", payload.organization_name);
  }

  if (payload.attachment) {
    formData.append("attachment", payload.attachment);
  }

  return formData;
};

export const getApiErrorMessage = (error, t) => {
  const data = error?.data || error?.response?.data;

  if (typeof data === "string") return data;
  if (data?.detail) return data.detail;
  if (data?.message) return data.message;

  const firstKey =
    data && typeof data === "object" ? Object.keys(data)[0] : null;

  if (firstKey) {
    const value = data[firstKey];

    if (Array.isArray(value)) return String(value[0]);
    if (typeof value === "string") return value;
  }

  return error?.message || t("not_success");
};